import React from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { motion } from 'framer-motion';

const HideOnScroll = ({ children }: { children: React.ReactElement }) => {
  const trigger = useScrollTrigger();

  const variants = {
    visible: {
      y: 0,
    },
    hidden: {
      y: -72,
    },
  };

  return (
    <motion.div
      className="globalHeader"
      initial="visible"
      variants={variants}
      animate={trigger ? 'hidden' : 'visible'}
      transition={{
        type: 'linear',
        duration: 0.18,
      }}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      {children}
    </motion.div>
  );
};

export default HideOnScroll;
